module.exports = __webpack_public_path__ + "img/vitamin-3.ed52477b.png";